import { gql } from "@apollo/client";

export const GET_CONEXIONES_A_BORRAR = gql`
query borrarConexiones(
    $idEvaluacion: Int!
    $idPaciente: Int!
    $fechaDesde: CustomDateTime!
    $fechaHasta: CustomDateTime!
) {
    borrarConexiones(
        idEvaluacion: $idEvaluacion
        idPaciente: $idPaciente
        fechaDesde: $fechaDesde
        fechaHasta: $fechaHasta
    ) {
        idConexion
        idEstadoNavigation{
            abreviacion
        }
        fechaConexion
        idEvaluacion
        idEvaluacionNavigation{
            precioDiario
            idPacienteNavigation{
                nombre
                apellido
            }
        }
    }
}`;

export const adaptConexionesABorrarArray = (data) => {
    const conexiones = data || [];
    return conexiones.map((conexion) => ({
        idConexion: conexion.idConexion,
        estado: conexion.idEstadoNavigation?.abreviacion,
        fechaConexion: conexion.fechaConexion,
        idEvaluacion: conexion.idEvaluacion,
        precioDiario: conexion.idEvaluacionNavigation?.precioDiario,
        nombrePaciente: conexion.idEvaluacionNavigation?.idPacienteNavigation?.nombre,
        apellidoPaciente: conexion.idEvaluacionNavigation?.idPacienteNavigation?.apellido,
        paciente: `${conexion.idEvaluacionNavigation?.idPacienteNavigation?.apellido}, ${conexion.idEvaluacionNavigation?.idPacienteNavigation?.nombre}`
    }));
};